"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _config = require("./config");
var _product = require("@/api/product");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'index',
  props: {
    checkedList: {
      //选中的数据
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tableFrom: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    name: {
      type: String,
      default: ''
    },
    showOperation: {
      type: Boolean,
      default: true
    },
    showSelection: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableColumns: []
      // checkedList: []
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:coupon:page:list'])) this.getList();
    if (this.showOperation) {
      this.tableColumns = _config.couponTableColumns;
    } else {
      this.tableColumns = _config.couponTableColumns.slice(0, -2);
    }
  },
  methods: {
    checkPermi: _permission.checkPermi,
    selectionChange: function selectionChange(selection) {
      // this.checkedList = selection
      this.$emit('changeSelection', selection);
    },
    // 列表
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      this.tableFrom.name = encodeURIComponent(this.name);
      (0, _product.marketingListApi)(this.tableFrom).then(function (res) {
        _this.tableData.data = res.list;
        _this.tableData.total = res.total;
        _this.listLoading = false;
      }).catch(function (res) {
        _this.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    onchangeIsShow: function onchangeIsShow(row) {
      this.$emit('onchangeIsShow', row);
    }
  }
};